<template>
    <nav class="Pagination" v-if="hasData">
        <div class="ButtonContainer">
            <PaginationButton title="Previous page" :rel="prevRel" :href="prevHref" name="previous" v-if="shouldDisplayPrevious" @click="store.setPage(router, currentPage - 1)">
                <i class="lnr-chevron-left ChevronIcon"></i>
            </PaginationButton>
        </div>

        <span class="Text">Page {{ currentPage }} of {{ totalPages }}</span>

        <div class="ButtonContainer">
            <PaginationButton title="Next page" :rel="nextRel" :href="nextHref" name="next" v-if="currentPage < totalPages" @click="store.setPage(router, currentPage + 1)">
                <i class="lnr-chevron-right ChevronIcon"></i>
            </PaginationButton>
        </div>
    </nav>
</template>
<script lang="ts" setup>
    import { computed } from 'vue';
    import PaginationButton from './PaginationButton/PaginationButton.vue';
    import { useSearchStore } from '@app/stores/useSearchStore';
    import { useRouter } from 'vue-router';

    const store = useSearchStore();
    const router = useRouter();
    const resultsLength = computed(() => store.pageData?.totalResultsCount || 0);
    const currentPage = computed(() => store.currentPage);
    const hasData = computed(() => resultsLength.value && resultsLength.value > 0);
    const shouldDisplayPrevious = computed(() => currentPage.value > 1 );
    const totalPages = computed(() => store.pageData?.pagesCount || 1);
    const refRegex = /([?&])page=\d+/;

    const nextHref = computed<string>(() => {
        const nextPage = currentPage.value + 1;
        const fullPath = router.currentRoute.value.fullPath;
        return fullPath.replace(refRegex, `$1page=${nextPage}`);
    });
    const prevHref = computed<string>(() => {
        const prevPage = currentPage.value - 1;
        const fullPath = router.currentRoute.value.fullPath;
        return fullPath.replace(refRegex, `$1page=${prevPage}`);
    });
    const prevRel = computed<string>(() => shouldDisplayPrevious.value && currentPage.value !== 2 ? 'nofollow' : 'prev');
    const nextRel = computed<string>(() => currentPage.value > 1 || currentPage.value === totalPages.value ? 'nofollow' : 'next');

</script>
<style scoped lang="scss">
    .Pagination {
        display: flex;
        height: 3.25rem;
        justify-content: space-between;
        align-items: center;
        @include PaddingAreas(1, 0);
        .ButtonContainer {
            height: 3rem;
            width: 3rem;
        }
        .Text {
            @include TextStyle(UiLargeRegular);
        }
        .ChevronIcon {
            font-size: 1.5rem;
        }
        @include Breakpoint(Medium, Large, ExtraLarge) {
            justify-content: center;
            gap: 3rem;
        }
    }
</style>